import { render, staticRenderFns } from "./TagGroup.vue?vue&type=template&id=5cd80a85&scoped=true"
import script from "./TagGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./TagGroup.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TagGroup.vue?vue&type=style&index=0&id=5cd80a85&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd80a85",
  null
  
)

export default component.exports